<template>
  <div v-show="visible">
    <div class="popup_wrap resultConfirm" ref="popup">
      <div class="popup_title">
        <p><span id="node_title">엑셀업로드</span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div v-show="isUpload">
          <div style="text-align: center;font-size: 15px;font-weight: bold">
            {{resultHistory.header}}
          </div>
          <div class="result_con">
            <dl class="rc_result">
              <dt>이전값</dt>
              <dd>{{resultHistory.oldValue}}</dd>
            </dl>
            <div class="rc_result_arrow">→</div>
            <dl class="rc_result">
              <dt>변경값</dt>
              <dd>{{resultHistory.newValue}}</dd>
            </dl>

            <ul class="result_info">
              <li style="background-color: #d7f1e1;">*<label for="info2">신규추가행</label><hr/></li>
              <li style="background-color: lightcyan;">*<label for="info2">값변경</label><hr/></li>
              <li style="background-color: #FFBEBA;">*<label for="info3">타입불일치</label><hr/></li>
<!--              <li><input type="checkbox" id="info4"><label for="info4">checkbox4</label></li>
              <li><input type="checkbox" id="info5"><label for="info5">checkbox5</label></li>
              <li><input type="checkbox" id="info6"><label for="info6">checkbox6</label></li>-->
            </ul>
          </div>
        </div>

        <div class="board_w_scroll_pop">
          <hot-table
            v-show="isUpload"
            ref="confirmHandsonRef"
            :settings="hotSettings"
            :key="hotKey"
            :licenseKey="'6c578-61cf1-e8cf5-b453c-1f850'"/>
          <div v-show="!isUpload">
            <div class="nodata_txt"><p>엑셀파일을 업로드 해주세요.</p></div>
          </div>
        </div>
      </div>
      <div class="popup_footer">
        <input type="file" name="excel_file_id" class="input-file-upload" style="display: none;" ref="excelUploadFileInput" @change="addFile($event, 'file')">
        <label v-show="!isUpload" class="btn_basic2 btn_type1 ce-file-upload" @click="triggerFileInput">파일 업로드</label>
        <a class="btn_type1" @click="saveData">적용</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import { HotTable } from '@handsontable/vue';
import {createNamespacedHelpers} from 'vuex';
import {
  groupBy,
  settingHeader,
  colWidthArray,
  checkActiveRow,
  generateUniqueID,
  DEFAULT_COL_INDEX,
  COL_PREFIX,
} from "@/util/HubHandsonTable";
import {v4} from "uuid";
const Hub = createNamespacedHelpers('Hub');

export default {
  components: {
    Loading,
    HotTable
  },
  data() {
    return {
      loading : null,
      hotKey : 0,
      visible : false,
      isUpload : false, //엑셀파일 업로드 여부
      resultHistory : {
        oldValue : null,
        newValue : null,
        header : "",
        label : "",
      },
      changeFlag : {
        "new" : "new" //새로추가
        , "change" : "change" //변경
        , "hold" : "hold" //변경없음
        , "error" : "error" //타입 불일치
      },
      hotInstance : null,
      mappingCellMetaData : null,
      hotSettings: {
        width: '100%',
        height: '100%',
        autoWrapRow: true,
        autoWrapCol: true,
        rowHeaders: true,
        colHeaders: true,
        autoColumnSize : false,
        afterChange: (async (changes, source) => {
          if (source === 'edit') {
            changes.forEach(([row, prop, oldValue, newValue]) => {
              const colIndex = this.hotInstance.getSettings().columns.findIndex(col => col.data == prop)
              const cellMeta = this.hotInstance.getCellMeta(row, colIndex);
              const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
              const experimentId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기
              const cellColMeta = this.hotInstance.getColumnMeta(colIndex);
              if (cellMeta.oldValue != newValue) {
                console.log(`Cell changed - Row: ${row}, Column: ${prop}, From: ${oldValue}, To: ${newValue}`);
                const colIndex = this.hotInstance.getSettings().columns.findIndex(col => col.data == prop)
                if ((cellColMeta.data == null || cellColMeta.data == '')
                    && (experimentId == null || experimentId == '')
                    && (rowId == null || rowId == '')
                ) {
                  alert(`데이터가 정상적이지 않습니다. 관리자에게 문의해주세요\n afterChange : cellMeta = ${JSON.stringify(cellMeta)}`);
                  this.close();
                  return;
                }
                if (cellMeta.changeFlag == this.changeFlag.hold) {
                  this.hotInstance.setCellMeta(row, colIndex, 'changeFlag', this.changeFlag.change);
                  this.hotInstance.setCellMeta(row, colIndex, 'className', 'custom-border-change');
                }
              } else if (cellMeta.changeFlag == this.changeFlag.change || cellMeta.changeFlag == this.changeFlag.error ) {
                this.hotInstance.setCellMeta(row, colIndex, 'changeFlag', this.changeFlag.hold);
                this.hotInstance.setCellMeta(row, colIndex, 'className', '');
              }
            });
            this.hotInstance.render();
          }
        }),
        afterOnCellMouseDown: (event, coords) => {
          const row = coords.row;
          const col = coords.col
          if (row < 0 && col >= 0) {
            // 해당 열의 메타정보를 가져옵니다.
            const colMeta = this.hotInstance.getColHeader(col);
            const columnInfo = this.hotInstance.getSettings().columns[col];
            console.log(`========================================`);
            console.log(`Selected Header [Column ${col}] - Header Label:`, colMeta,` || Column Meta:`, columnInfo);
            console.log(`========================================`);
          } else if(col < 0 && row >= 0){
            // 해당 row의 메타정보를 가져옵니다.
            const rowLabel = this.hotInstance.getRowHeader(row);
            console.log(`#####################`);
            console.log(`Selected Header [Row ${row}] - Header Label:`, rowLabel);
            console.log(`####################`);
          }else if (row >= 0 && col >= 0) {
            // 선택한 셀의 컬럼데이터
            const columnInfo = this.hotInstance.getSettings().columns[col];
            // 선택한 셀의 데이터
            const cellData = this.hotInstance.getDataAtCell(row, col);
            // 선택한 셀의 메타데이터
            const cellMeta = this.hotInstance.getCellMeta(row, col);
            this.resultHistory.newValue = cellData;
            this.resultHistory.oldValue = cellMeta.oldValue;
            this.resultHistory.header = columnInfo.name;
            console.log(`**********************`);
            console.log(`Selected cell [${row}, ${col}] - Data:`, cellData, ` || Meta:`, cellMeta);
            console.log(`**********************`);
          }
        },
      }
    }
  },
  computed : {
    ...Hub.mapGetters(['getResultConfirmPopFlag','getSelectedReleaseProcess']),
  } ,
  watch: {
    getResultConfirmPopFlag: {
      // deep: true,
      // immediate: true,
      async handler(value) {
        if (value === true) {
          this.show()
          ++this.hotKey;
        } else {
          this.visible = false;
          this.isUpload = false;
          this.mappingCellMetaData = null;
          this.resultHistory = {
            oldValue: null,
            newValue: null,
            header: "",
            label: "",
          }
        }
      }
    },
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setResultConfirmPopFlag",
        ]
    ),
    async initializeConfirm() {
      try {
        const {nestedHeaders, columns} = await settingHeader(
            this.$wApi,
            this.$route,
            this.getSelectedReleaseProcess
        );

        this.hotSettings.nestedHeaders = nestedHeaders;
        this.hotSettings.columns = columns;

        console.log('colWidthArray=',colWidthArray)
        // hotInstance는 hot-table 컴포넌트가 렌더된 이후에 접근 가능
        this.$nextTick(() => {
          this.hotInstance = this.$refs.confirmHandsonRef.hotInstance;
          this.hotInstance.updateSettings({
            readOnly: false,
            nestedHeaders: nestedHeaders,
            columns: columns,
            hiddenColumns: {
              columns: [0, 1], // 숨길 컬럼의 인덱스
              indicators: false, // 숨긴 열의 표시기(true) 또는 숨기기(false)
            },
            colWidths: colWidthArray,
            afterGetColHeader: (col, TH) => {
              // 컬럼별로 헤더 배경색 설정
              // 컬럼 색상 설정
              if (columns[col] && columns[col].tagType) {
                switch (columns[col].tagType) {
                  case "PROCESS":
                    TH.style.backgroundColor = '#D8E5F5';
                    break;
                  case "MATERIAL":
                    TH.style.backgroundColor = '#E2DDE9';
                    break;
                  case "EQUIPMENT":
                    TH.style.backgroundColor = '#DAEDE8';
                    break;
                }
              }
            },
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    buildRowData(cellsFromDB, columns) {
      //1. celldata 그룹화 및 row order 기준 정렬. [[key,value],[key,value]]구조
      const cellGroupByRowId = groupBy(cellsFromDB,"rowId").sort((a,b) => a[1][0].rowOrder - b[1][0].rowOrder);
      console.log("[ResultConfirm] cellGroupByRowId not exclusive",JSON.parse(JSON.stringify(cellGroupByRowId)));

      //2.column에 매핑되는 cell 관련 제어(재공개시 없던 신규속성이 추가된경우 or 재공개시 있던 값이 사라진경우)
      const columnOrder = columns.map(col => col.data);
      cellGroupByRowId.forEach(row => {
        const rowId = row[0];
        const cellItemArr = row[1];
        const experimentId = cellItemArr[0].experimentId;
        const processId = cellItemArr[0].processId;
        //1. 재공개시 없던 신규속성이 추가된경우 추가
        columns.filter(col => col.processPropertyType != 'HIDDEN').forEach(col => {
          const found = cellItemArr.some((cell) => COL_PREFIX+cell.processPropertyId === col.data);
          if(!found){
            confirm(`엑셀파일이 최근 공개버전과 일치하지않습니다. 최신 엑셀로 업데이트해주세요.\n추가된 속성ID = ${col.name}`);
            this.close();
            throw Error('엑셀업로드 에러');
          }
        });

        //2. 재공개시 있던 속성이 제거된경우 cell 제거
        for (let i = cellItemArr.length - 1; i >= 0; i--) {
          const cell = cellItemArr[i];
          const found = columns.filter(col => col.processPropertyType != 'HIDDEN').some((col) => col.data === COL_PREFIX+cell.processPropertyId);

          // column 배열에 없는 processPropertyId를 가진 cell은 제거
          if (!found) {
            confirm(`엑셀파일이 최근 공개버전과 일치하지않습니다. 최신 엑셀로 업데이트해주세요.\n제거된 속성ID = ${cell.processPropertyId}`);
            this.close();
            throw Error('엑셀업로드 에러');
          }
        }
        //3. row별 cell정렬
        cellItemArr.sort((a, b) => {
            return columnOrder.indexOf(a.processPropertyId) - columnOrder.indexOf(b.processPropertyId);
        });
      });
      console.log("[ResultConfirm] cellGroupByRowId",cellGroupByRowId);
      //[rowId, cellDataArray] 형태
      this.mappingCellMetaData = cellGroupByRowId;

      const handsonTableData = {};
      cellGroupByRowId.forEach(rowInfo => {
        //console.log('rowInfo',rowInfo);
        if (!handsonTableData[rowInfo[0]]) {
          handsonTableData[rowInfo[0]]= {}; // 새로운 행을 생성
        }
        rowInfo[1].forEach((cell,index) => {
          if(index == 0){
            handsonTableData[rowInfo[0]][COL_PREFIX+'rowId'] = rowInfo[0];
            handsonTableData[rowInfo[0]][COL_PREFIX+'experimentId'] = cell.experimentId;
          }
          handsonTableData[rowInfo[0]][COL_PREFIX+cell.processPropertyId] = cell.newValue;
        })
      });
      console.log('[ResultConfirm] buildRowData',Object.values(handsonTableData))
      return Object.values(handsonTableData);
    },
    applyCellMetadata(hotInstance) {
      const rowCount = hotInstance.countRows();
      const colCount = hotInstance.countCols();
      // 각 셀을 순회하면서 메타데이터의 uuid를 확인
      for (let row = 0; row < rowCount; row++) {
        const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
        for (let col = 2; col < colCount; col++) { //숨김컬럼 이후부터 setting
          const cellColMeta = hotInstance.getColumnMeta(col);
          const experimentId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기
          const metaData = this.mappingCellMetaData[row][1][col-2];
          if(this.mappingCellMetaData[row][1][col-2] == null){
            alert('mappingCellMetaData가 존재하지 않습니다.');
            throw Error("잘못된 엑셀!. mappingCellMetaData가 존재하지않습니다.")
          }
          switch (metaData.changeFlag){
            case this.changeFlag.new :
              this.hotInstance.setCellMeta(row, col, 'className', 'custom-border-new');
              if(col == DEFAULT_COL_INDEX.no && metaData.newValue == ''){
                const {companyName, name, companyCode} = this.user;
                const value = generateUniqueID(this.hotInstance.getSourceData(),cellColMeta.data,companyCode,name);
                this.hotInstance.setDataAtCell(row,col,value);
              }
              break;
            case this.changeFlag.change :
              this.hotInstance.setCellMeta(row, col, 'className', 'custom-border-change');
              break;
            case this.changeFlag.error :
              this.hotInstance.setCellMeta(row, col, 'className', 'custom-border-error');
              break;
            case this.changeFlag.hold :
              break;
          }
          hotInstance.setCellMeta(row, col, 'rowId', rowId);
          hotInstance.setCellMeta(row, col, 'processPropertyId', metaData.processPropertyId);
          hotInstance.setCellMeta(row, col, 'experimentId', experimentId);
          hotInstance.setCellMeta(row, col, 'oldValue', metaData.oldValue);
          hotInstance.setCellMeta(row, col, 'changeFlag', metaData.changeFlag);
        }
      }
      //handsontable visible
      this.loading = false;
    },
    triggerFileInput(){
      this.$refs.excelUploadFileInput.value = '';  // input 요소를 리셋해서 동일한 파일을 다시 선택할 수 있도록 함
      this.$refs.excelUploadFileInput.click();  // 파일 선택창을 강제로 열기
    },
    async addFile(e, key = "file") {
      if(e.target.files.length > 1){
        alert("하나의 파일만 업로드 가능합니다.")
        return;
      }

      const fileExt = e.target.files[0].name.split('.')[1]
      if(fileExt != 'xlsx'){
        alert("엑셀 파일만 업로드 가능합니다.")
        return;
      }

      try {
        this.loading = true;
        const uploadPromises = Array.from(e.target.files).map(async (file) => {
          if (file.size > 1073741824) { // 1GB = 1,073,741,824 bytes
            alert("파일 크기가 1GB를 초과합니다. 1GB 이하의 파일만 업로드 가능합니다.");
            e.target.value = ''; // 선택된 파일 리셋
            return;
          }
          if(!['xlsx'].includes(file.name.split('.')[1])){
            alert('허용된 확장자가 아닙니다.');
            e.target.value = ''; // 선택된 파일 리셋
            return;
          }
          const formData = new FormData();
          formData.append('file', file);
          formData.append('processId', this.$route.query.processId);
          if (file) {
            const res = await this.$wApi.experiment.uploadExcel(formData);
            if(!res.error){
             await this.initializeConfirm();
             this.hotInstance.updateSettings({
                data: this.buildRowData(res, this.hotSettings.columns),
              });
              // 데이터 로드 후 메타데이터 적용!. 처음 세팅시에만 활용함.
              this.applyCellMetadata(this.hotInstance);
              this.hotInstance.render();
              this.isUpload = true;
            }else{
              alert(`${res.message}`);
              this.isUpload = false;
              this.mappingCellMetaData = null;
            }
          }
        });
        await Promise.all(uploadPromises);
        //console.log('this.fileArray=', this.fileArray)
      } catch (e) {
        alert('upload Error!')
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async saveData() {
      const flag = await confirm("적용 시 모든 데이터가 엑셀데이터 기준으로 적용됩니다\n(존재하지않는 행은 삭제됩니다.)\n적용하시겠습니까?");
      if(!flag){
        return
      }
      const rowData = this.hotInstance.getData();
      const cellData = [];
      try {
        rowData.forEach((row, rowIndex) => {
          Object.keys(row).forEach((colKey, colIndex) => {
            const cellValue = row[colIndex];
            const cellColMeta = this.hotInstance.getColumnMeta(colIndex);
            const processPropertyId = cellColMeta.data.replace(COL_PREFIX,'');
            const cellMeta = this.hotInstance.getCellMeta(rowIndex, colIndex);
            const rowId = this.hotInstance.getDataAtCell(rowIndex,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
            const experimentId = this.hotInstance.getDataAtCell(rowIndex,DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기
            if((processPropertyId == null || processPropertyId == '')
                && (experimentId == null || experimentId == '')
                && (rowId == null || rowId == '')
            ){
              alert("데이터가 정상적이지 않습니다. 관리자에게 문의해주세요");
              throw Error(`saveData error`);
              return;
            }
            if(processPropertyId == 'experimentId' || processPropertyId =='rowId' || cellMeta.changeFlag == this.changeFlag.hold) return; //숨김컬럼 및 변경사항이 없는 컬럼은 저장하지않음.
            cellData.push({
              rowId: rowId,
              processPropertyId: processPropertyId,
              value: cellValue,
              experimentId: experimentId
            });
          });
        });
        console.log('cellData = ', cellData);
        console.log('checkActiveRow = ', checkActiveRow(this.hotInstance));
        if(cellData.length == 0){
          alert("저장 데이터가 존재하지 않습니다.");
          return;
        }
        this.loading = true;
        const saveRes = await this.$wApi.experiment.saveExperimentData({
          activeRowList : checkActiveRow(this.hotInstance),
          processId : this.$route.query.processId,
          experimentLogFlag : "EXCELSAVE",
          releaseExperimentDataList : cellData,
          logMemo : "",
        });
        if(!saveRes.error){
          alert("저장완료.");
          location.reload();
        }else{
          alert(saveRes.message);
          this.close();
        }
      } catch (e) {
        console.log('saveData Error!!', e.message)
      }finally {
        this.loading = false;
      }
    },
    show() {
      this.visible = true;
    },
    close() {
      this.setResultConfirmPopFlag(false);
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.resultConfirm  {display:block;position:fixed; width:1500px;height:90%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
.highlight {
    cursor: pointer;
    font-weight: bold;
    border: dashed!important;
    border-color: red!important;
    border-width: 2px!important;
}

/* 도움말 스타일 */
.tooltip {
    display: none;
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    z-index: 999999;
}

.tooltip.show {
    display: block;
}

.custom-border-new {
  color : black!important;
  background : #d7f1e1!important;
}

.custom-border-change {
  color : black!important;
  background : lightcyan!important;
}

.custom-border-error {
  color : black!important;
  background : #FFBEBA!important;
}

@media screen and (max-width: 1550px) {
  .resultConfirm {width:95%;}
}

</style>